import React, { useState, useEffect, Fragment } from 'react';
import PrintPanel from "./PrintPanel";
import { connect } from "react-redux";
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Card, Accordion, Spinner, Nav } from "react-bootstrap";
import Swal from "sweetalert2";
import Styles from "./LibrairyPanel.scss"
import Icon from "@mdi/react";



const LibraryPanel = (props) => {

    const [items, setItems] = useState()
    const [rows, setRows] = useState([])
    const [ref, setRefs] = useState([])
    const [asData, setAsData] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [sectionType, setSectionType] = useState('plu')
    const docs_structure = {
        

        'plu':
            [
                { 'path': '0_Procedure', 'libelle': 'Procédure' },
                { 'path': '1_Rapport_de_presentation', 'libelle': 'Rapport de présentation' },
                { 'path': '2_PADD', 'libelle': 'PADD' },
                { 'path': '3_Reglement', 'libelle': 'Réglement' },
                { 'path': '4_Annexes', 'libelle': 'Annexes' },
                { 'path': '5_Orientations_amenagement', 'libelle': 'Orientations d\'aménagemnt' }
            ],
        'plui':
            [
                { 'path': '0_Procedure', 'libelle': 'Procédure' },
                { 'path': '1_Rapport_de_presentation', 'libelle': 'Rapport de présentation' },
                { 'path': '2_PADD', 'libelle': 'PADD' },
                { 'path': '3_Reglement', 'libelle': 'Réglement' },
                { 'path': '4_Annexes', 'libelle': 'Annexes' },
                { 'path': '5_Orientations_amenagement', 'libelle': 'Orientations d\'aménagemnt' }
            ],
        'cc':
            [
                { 'path': '0_Procedure', 'libelle': 'Procédure' },
                { 'path': '1_Rapport_de_presentation', 'libelle': 'Rapport de présentation' },
                { 'path': '4_Annexes', 'libelle': 'Annexes' }
            ]
    }
    const sectionLabels = {
        "procedure": 'Procédure',
        "rapport_de_presentation": 'Rapport de présentation',
        "padd": 'PADD',
        "reglement": 'Réglement',
        "annexes": 'Annexes',
        "orientation_amenagement": 'Orientations d\'aménagemnt'
    }

    useEffect(() => {
        (props.currentCom) ? fetchData(props.currentCom) : null;
    }, [props.currentCom])

    const fetchData = (com) => {
        setIsLoading(true)
        const params = {
            'code_com': com,
            'type': sectionType
        }
        //axios.post('/Api/docs_library', params)
        axios.get(`Api/docs_library/lib/${com}`)
            .then(result => {
                setItems(result.data)
                setIsLoading(false)
            }).catch(err => { console.log(err) })
    }
    /*
        useEffect(() => {
            if (rows && rows.length > 0) {
                const result = parsStructure(rows);
                console.log('Parsed Structure:', result); // Log to inspect structure
        
                // Ensure the structure is properly defined before accessing it
                if (result) {
                    let baseObj = result.urbanisme[sectionType][props.currentCom.substr(0, 2)];
                    let resources = null;
        
                    for (let prop in baseObj) {
                        if (prop.indexOf(props.currentCom) >= 0) {
                            resources = baseObj[prop]['Pieces_ecrites'];
                        }
                    }
        
                    if (resources) {
                        docs_structure[sectionType].forEach((item, index) => {
                            Object.keys(resources).forEach(itemKey => {
                                if (item.path === itemKey) {
                                    docs_structure[sectionType][index].files = resources[itemKey];
                                }
                            });
                        });
                    }
        
                    setItems(docs_structure);
                } else {
                    console.error('Expected structure not found in result:', result);
                }
            }
        }, [rows]);
        */
    useEffect(() => {
        (items) ? console.log(items) : null
    }, [items])

    const handlerExportAll = () => {

        const params = {
            'code_com': props.currentCom,
            'type': sectionType
        }
        $(".swal2-modal").css('background-color', '#d4d4d4');

        Swal.queue([{
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: 'Téléchargement',
            html: '<h3 class="text-light">Préparation de vos fichiers .....</h3>',
            background: '#dddddd',
            showConfirmButton: false,
            showCloseButton: false,
            //showCancelButton: false,
            onOpen(popup) {
                Swal.showLoading();
                return axios.post('/Api/docs_library/arch', params)
                    .then(result => {
                        Swal.hideLoading();
                        if (result.data) {
                            Swal.update({
                                icon: 'success',
                                title: 'Téléchargement',
                                allowOutsideClick: true,
                                allowEscapeKey: true,
                                showCloseButton: true,
                                html: '<div class="text-light"><h3 >votre archive est diponible :</h3>' +
                                    +'<p>' + result.data.nb_files + ' fichiers en une archive de ' + result.data.size + 'M</p>' +
                                    '<br><a href="/temp/' + result.data.arch_name + '">' + result.data.arch_name + '</a></div>',
                            })

                        }
                    }).catch(err => {
                        console.log(err)
                        Swal.update({
                            icon: 'error',
                            title: 'Erreur',
                            background: '#f1f1f1',
                            showCloseButton: true,
                            showCancelButton: true,
                            html: '<div><h5 >Impossible d\'exporter vos éléments</h5><br></div>',

                        })
                    })
            }

        }])
    }



    const renderItemTitle = (item, index, isEmpty = false) => {
        return (
            <div
                key={index}
                className={(isEmpty) ? "text-muted themaStyle" : "mb-2 pb-1  themaStyle"}
            >
                <i
                    className={(isEmpty) ? "bi bi-folder-x text-muted" : "bi bi-folder2-open eu-btn-icon"}
                    style={{ "fontSize": "20px", "paddingRight": "5px" }}
                ></i>
                <span className={(isEmpty) ? "text-muted" : "font-weight-bold"}> {(index + 1) + ' : ' + item}</span>
            </div>
        )
    }

    const renderFilePath = (strFilePath, key, section) => {
        const fileInfo = strFilePath.split('_')
        //let path = _.drop(fileInfo)
        //path = _.join(path,'/')
        //console.log(fileInfo)
        const staticPath = 'https://static.k8s.urba-earth.fr/';
        let docNumber = fileInfo[fileInfo.length - 1].split('.')[0];
        let path = staticPath + 'pdf/urbanisme/' + sectionType + '/' + props.currentCom.substr(0, 2) + '/' + props.currentCom + '_' + sectionType.toUpperCase() + '_' + docNumber + '/Pieces_ecrites/' + section + '/' + strFilePath;


        return (
            <div
                key={key}
                onClick={() => { window.open(path) }}
                className={"docStyle d-flex justify-content-between ronded"}
            >
                <span >{strFilePath}</span>
                <i className="bi bi-arrow-down-circle" style={{ "fontSize": "16px", "color": "var(--theme-primary)" }} ></i>
            </div>
        )
    }

    const renderThema = (item, index) => {
        //(item.files && item.files.length > 0)?setAsData(true):null;
        return (
            <li key={index} className="list-group-item d-flex  align-items-left ueThemeBackground" style={{ "color": "var(--theme-color)!important", "border": "none" }}>
                {(item.files && item.files.length > 0)
                    ? <div style={{ "width": "100%" }}>
                        {renderItemTitle(item.libelle, index)}
                        {
                            item.files.map((filePath, key) => {
                                return (renderFilePath(filePath, key, item.path))
                            })

                        }
                    </div>
                    : <div style={{ "width": "100%" }}>
                        {
                            renderItemTitle(item.libelle, index, true)

                        }
                    </div>
                }
            </li>
        )
    };
    const renderSection = (sectionName, sectionData) => {
        
        let isEmpty= false;
        if (!sectionData || Object.keys(sectionData).length === 0) {
            isEmpty= true;
        }

        return (
            <li key={sectionName} className="list-group-item d-flex  align-items-left ueThemeBackground" style={{ "color": "var(--theme-color)!important", "border": "none" }}>

                <div
                    key={sectionName}
                    className={(isEmpty) ? "text-muted themaStyle" : "mb-2 pb-1  themaStyle"}
                    style={{ "width": "100%" }}
                >
                    <i
                        className={(isEmpty) ? "bi bi-folder-x text-muted" : "bi bi-folder2-open eu-btn-icon"}
                        style={{ "fontSize": "20px", "paddingRight": "5px" }}
                    ></i>
                    <span className={(isEmpty) ? "text-muted" : "font-weight-bold"}>{sectionLabels[sectionName]}</span>
                    {Object.entries(sectionData).map(([filename, url]) => (
                        <div key={filename}
                            onClick={() => { window.open(url) }}
                            className={"docStyle d-flex justify-content-between rounded"}
                            style={{ "width": "100%" }}
                        >
                            <span >{filename}</span>
                            <i className="bi bi-arrow-down-circle" style={{ "fontSize": "16px", "color": "var(--theme-primary)" }} ></i>
                        </div>
                    ))}
                </div>
            </li>
        );
    };

    return (
        <div className={"card ueThemeBackground libraryPanel"}  >
            <div className={"libraryPanelHeader d-flex flex-row justify-content-between w-100 shadow"}>
                <div className={"libraryPanelTitle"}>Bibliothèque</div>
                <div
                    onClick={(e) => props.setLeftPanelOpen(false)}
                    className={"ue-navdata-close btn "}
                >
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.91659 0.670844L5.32909 0.0833435L2.99992 2.41251L0.670752 0.0833435L0.083252 0.670844L2.41242 3.00001L0.083252 5.32918L0.670752 5.91668L2.99992 3.58751L5.32909 5.91668L5.91659 5.32918L3.58742 3.00001L5.91659 0.670844Z" fill="#F2F2F2" />
                    </svg>
                </div>
            </div>
            {props.subscription ? (
                <div className={"libraryPanelContent"}>
                    {isLoading ? (
                        <div className="text-center my-2"><Spinner animation="border" size={'sm'} /></div>
                    ) : items ? (
                        <ul className="list-group" style={{ "width": "100%" }}>
                            {Object.entries(items).map(([sectionName, sectionData]) =>
                                renderSection(sectionName, sectionData)
                            )}
                        </ul>
                    ) : (
                        <div className={"d-flex flex-column flex-center justify-content-center align-content-center"}>
                            <div className={"card ueThemeBackground"}>
                                <div className={"card-body text-center"}>
                                    <h1 className={"text-danger"}><i className="bi bi-exclamation-diamond"></i></h1>
                                    <h4 className={'p-2'}>Merci de selectionner une parcelle <br />afin d'afficher les données correspondantes</h4>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className={"libraryPanelContent"}>
                    <div className="text-center">
                        <span>
                            <i className="fas fa-ban fa-2x"></i> <br />Vous n'avez pas accès<br /> à cette section !
                        </span>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className={"card ueThemeBackground libraryPanel"}  >
            <div className={"libraryPanelHeader d-flex flex-row justify-content-between w-100 shadow"}>
                <div className={"libraryPanelTitle"}>Bibliothèque</div>
                <div
                    onClick={(e) => props.setLeftPanelOpen(false)}
                    className={"ue-navdata-close btn "}
                >
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.91659 0.670844L5.32909 0.0833435L2.99992 2.41251L0.670752 0.0833435L0.083252 0.670844L2.41242 3.00001L0.083252 5.32918L0.670752 5.91668L2.99992 3.58751L5.32909 5.91668L5.91659 5.32918L3.58742 3.00001L5.91659 0.670844Z" fill="#F2F2F2" />
                    </svg>
                </div>
            </div>
            <div className={"libraryPanelContent"}>


                {(props.subscription) ?
                    (!isLoading) ?
                        <Fragment>
                            {(items) ?
                                <Fragment>
                                    <ul className="list-group" style={{ "width": "100%" }}>
                                        {
                                            items.map((item, index) => {
                                                return (renderThema(item, index))
                                            })
                                        }
                                    </ul>
                                    {
                                        (asData) ?
                                            <button className={'btn btn-outline-primary btn-block mt-3'}
                                                onClick={handlerExportAll}>
                                                <i className="bi bi-save2"></i> Tout exporter</button>
                                            : <button className={'btn btn-outline-primary btn-block mt-3'} disabled>
                                                <i className="bi bi-save2"></i> Pas de donnée à exporter
                                            </button>
                                    }
                                </Fragment>
                                : <div className={"d-flex flex-column flex-center justify-content-center align-content-center"}>
                                    <div className={"card ueThemeBackground"}>
                                        <div className={"card-body text-center"}>
                                            <h1 className={"text-danger"}><i className="bi bi-exclamation-diamond"></i></h1>
                                            <h4 className={'p-2'}>Merci de selectionner une parcelle <br />afin d'afficher les données correspondantes</h4>
                                        </div>
                                    </div>
                                </div>
                            }
                        </Fragment>
                        : <div className="text-center my-2"><Spinner animation="border" size={'sm'} /></div>
                    : <div className="text-center">
                        <span>
                            <i className="fas fa-ban fa-2x"></i> <br />Vous n'avez pas acces<br /> à cette section !
                        </span>
                    </div>
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        currentCom: state.MapReducer.currentCom,
        subscription: state.MeReducer.subscription,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        hideDataPanel: () => dispatch({ type: 'HIDE_LAYERS_STACK' }),
        setLeftPanelWidth: (e) => dispatch({ type: 'SET_LEFT_PANEL_WIDTH', data: e }),
        setLeftPanelOpen: (e) => dispatch({ type: 'SET_LEFT_PANEL_OPEN', data: e }),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(LibraryPanel);

